import Vue from 'vue'
import XRTop  from './top'

export default XRTop




// WEBPACK FOOTER //
// ./src/components/usercenter/top/index.js